import React, { Component } from 'react';
import { TagPicker } from 'office-ui-fabric-react/lib/Pickers';
import { Label } from 'office-ui-fabric-react';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { DataCompte } from '../../data/DataCompte.jsx';


/*
***************************************************************
PROPS:
    loginCompte : valeur selectionnée
    idSociete : société dont dépend le compte
    required : défini si le contrôle est obligatoire
    onChanged : évenement
    disabled : Saisie désactivée
    label : label du  ctrl
***************************************************************
*/

export class PickerCompte extends Component {
    _creationContent() {
        let errorMessage = this.props.required && this.state.loginCompte == null;
        let messageErreurChampObligatoire = Scriba.officeUI().comboBox().messageChampObligatoire(this.state.loginCompte);

        return (
            <div>
                <Label required={this.props.required}>{this.props.label}</Label>
                <TagPicker
                    className={(errorMessage ? "champObligatoire_Picker" : "")}
                    onResolveSuggestions={this._onResolveSuggestions}
                    onChange={this._onChange}
                    selectedItems={this.state.selectedItems}
                    pickerSuggestionsProps={{
                        suggestionsHeaderText: 'Comptes',
                        noResultsFoundText: 'Aucun compte correspondant'
                    }}
                    itemLimit={1}
                    disabled={this.props.disabled}
                />

                {(errorMessage ? <p className="errorMessage_Picker"><span>{messageErreurChampObligatoire}</span></p> : null)}
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = {
            idSociete: 0,
            loginCompte: null,
            selectedItems: null
        };
    }

    _chargementDonnees() {
        if (this.props.loginCompte != null && this.props.loginCompte !== "") {
            DataCompte._chargementFicheCompte(this.props.loginCompte)
                .then(responseFetch => {
                    let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    let tabClient = [];
                    let listCompte = responseFetch.reponseAPIobjet;

                    listCompte.map(compte => {
                        tabClient.push({
                            key: compte.loginCompte,
                            name: compte.loginCompte + ' - ' + compte.nom + ' ' + compte.prenom
                        });
                    });

                    this.setState({
                        loginCompte: this.props.loginCompte,
                        idSociete: this.props.idSociete,
                        selectedItems: (tabClient.length === 1 ? tabClient : [])
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.idSociete = 0;
                    stateTemp.loginCompte = null;
                    stateTemp.selectedItems = null;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
        }
    }

    _onResolveSuggestions = (filterText, tagList) => {

        return DataCompte._onResolveSuggestions(filterText, this.props.idSociete)
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);
                let tabClient = [];

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    let listCompte = responseFetch.reponseAPIobjet;

                    listCompte.map(compte => {
                        tabClient.push({
                            key: compte.loginCompte,
                            name: compte.loginCompte + ' - ' + compte.nom + ' ' + compte.prenom
                        });
                    });
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }

                return tabClient;
            });
    };

    _onChange = (items) => {
        this.setState({ selectedItems: items });

        let loginCompte = null;

        if (items[0]) {
            loginCompte = items[0].key;
        }

        this.setState({ loginCompte: loginCompte });

        this.props.onChange(loginCompte);
    };

    componentDidMount() {
        this._chargementDonnees();
    }

    componentDidUpdate() {
        if ((this.props.loginCompte !== null & this.props.loginCompte !== this.state.loginCompte) | (this.props.idSociete !== null & this.props.idSociete !== this.state.idSociete)) {
            this._chargementDonnees();
        }
    }

    render() {
        return this._creationContent();
    }
}